import React from "react";
import { User as UserModel } from "../../models/user";
import FooterBlock from "../../components/Footer/Footer";
import Store from "./components/Store";
import LoggedOutView from "../LoggedOutPage/LoggedOutPage";

interface StoreProps {
  loggedInUser: UserModel | null;
}

const StorePage = ({ loggedInUser }: StoreProps) => {
  return (
    <div className="startBellowNavbar pageBlock">
      {loggedInUser ? (
        <>
          <Store />
          <FooterBlock />
        </>
      ) : (
        <LoggedOutView />
      )}
    </div>
  );
};

export default StorePage;
